import { gql } from 'react-apollo';

export default gql`
  mutation updateInvestorAffiliation(
    $affiliationType: AffiliationType!
    $professionalDesignation: ProfessionalDesignation
  ) {
    updateInvestorAffiliation(
      input: {
        affiliationType: $affiliationType
        professionalDesignation: $professionalDesignation
      }
    ) {
      _id
      accreditationStatus
      affiliationType
      professionalDesignation
    }
  }
`;



// WEBPACK FOOTER //
// ./src/apollo/mutations/updateInvestorAffiliation.js